var styles = {
  "AppProvider": "Online-Store-UI-AppProvider_yx2qd"
};

export { styles as default };
